module.exports = __webpack_public_path__ + "img/painty_the_pirate.591af2d3.jpg";